/**
 * Pre-rendered loop of each subtitle animation, shown in the animation
 * carousel instead of one live Remotion Player per card. Rendered by
 * scripts/render-subtitle-animation-previews.ts. The CDN caches /videos
 * immutably, so re-rendering an existing preview means bumping the version.
 */
export const ANIMATION_PREVIEW_DIR = '/videos/subtitle-animations/v1';

export function animationPreviewSlug(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function animationPreviewUrl(name: string): string {
  return `${ANIMATION_PREVIEW_DIR}/${animationPreviewSlug(name)}.mp4`;
}
